import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(errMsg(err));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen gradient-navy flex items-center justify-center px-5">
      <form onSubmit={submit} className="card-lux p-8 w-full max-w-sm animate-fade-up" data-testid="login-form">
        <div className="w-16 h-16 rounded-full bg-gold/15 text-gold flex items-center justify-center mx-auto mb-5">
          <Lock size={28} />
        </div>
        <p className="text-center tracking-[0.4em] text-gold text-sm mb-1">QAMARIA</p>
        <h1 className="font-display text-2xl text-center text-offwhite mb-8">لوحة الإدارة</h1>
        <label className="text-sm text-muted2 mb-1.5 block">البريد الإلكتروني</label>
        <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
          className="w-full card-lux p-3 bg-navy2 text-offwhite outline-none focus:ring-1 focus:ring-gold mb-4" />
        <label className="text-sm text-muted2 mb-1.5 block">كلمة المرور</label>
        <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
          className="w-full card-lux p-3 bg-navy2 text-offwhite outline-none focus:ring-1 focus:ring-gold mb-6" />
        <button data-testid="login-submit" disabled={loading} className="btn-gold w-full py-3.5 rounded-full flex items-center justify-center gap-2 disabled:opacity-50">
          {loading && <Loader2 className="animate-spin" size={18} />} دخول
        </button>
      </form>
    </div>
  );
}
